import React, { useState } from "react";
import { useObserver } from "mobx-react-lite";
import { Box } from "@material-ui/core";
import { BaseModal } from "Components/Modal/BaseModal";
import { CancelButton } from "Globals/Styles/Control/Buttons";
import { useRouter } from "@shoothill/core";
import styled from "styled-components";
import { ReportModalStyle } from "Views/Project/Modals/Modal.Styles";
import { TestAndInspectionsListModel } from "./TestAndInspectionsListModel";
import { formatDate, formatTime } from "Utils/Format";
import { SHBox } from "Components/Box";
import MaterialTable from "material-table";
import { PatchedPagination } from "Components/Table/PatchedPagination";
import * as Defaults from "../../../../../Globals/Defaults/TableOptions";
import { TestAndInspectionsListViewModel } from "./TestAndInspectionsListViewModel";

interface ICreatedModalProps {
    open?: boolean;
    onClose(): void;
    date: Date;
}

export const TestAndInspectionsView: React.FC<ICreatedModalProps> = (props) => {
    const { match } = useRouter();
    const { projectid } = match.params as any;
    const { open, onClose, date } = props;
    const [listViewModel] = useState(() => new TestAndInspectionsListViewModel(projectid, date));

    const COLUMNS8 = "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr";
    const COLUMNS2 = "1fr 1fr";

    return useObserver(() => (
        <BaseModal
            open={open}
            onClose={onClose}
            title={"Test and Inspections"}
            PaperComponent={ReportModalStyle}
            actions={
                <>
                    <CancelButton onClick={onClose}>Cancel</CancelButton>
                </>
            }
        >
            <DelaysModel>
                <MaterialTable
                    columns={[
                        { title: "Inspection type", field: "inspectionTypeDisplayName" },
                        {
                            title: "Reference No.",
                            field: "serialRegistrationNo",
                            render: (rowData: TestAndInspectionsListModel) => (
                                <SHBox>
                                    <SHBox>{`CDG-${listViewModel.referenceNumber(rowData.serialRegistrationNo)}`}</SHBox>
                                </SHBox>
                            ),
                        },
                        {
                            title: "Created",
                            field: "createdDate",
                            render: (rowData: TestAndInspectionsListModel) => (
                                <SHBox>
                                    <SHBox>
                                        {rowData.createdDate !== "" ? formatDate(rowData.createdDate) : "-"} @{rowData.createdDate !== "" ? formatTime(rowData.createdDate) : "-"}
                                    </SHBox>
                                    <SHBox>{rowData.firstName + " " + rowData.lastName ? `by ${rowData.firstName + " " + rowData.lastName} ` : ""}</SHBox>
                                </SHBox>
                            ),
                            defaultSort: "desc",
                        },
                    ]}
                    components={{
                        Pagination: PatchedPagination,
                    }}
                    options={Defaults.GetDarwinTableOptions()}
                    data={listViewModel.testAndInspectionsListItems}
                    onRowClick={(e, rowData) => {
                        listViewModel.handleRowClick(e, rowData!);
                    }}
                    title=""
                />
            </DelaysModel>
        </BaseModal>
    ));
};

const DelaysModel = styled(Box)`
    hr {
        background-color: transparent !important;
        border-top: 1px dashed rgba(206, 212, 218, 1) !important;
    }
`;
